import { getStytchJWT } from './getStytchJWT'
import { getSessionMemberInfoFromStytchPayload } from '@/utilities/shared/stytchSession'

/**
 * Extract key information from Stytch session JWT cookie.
 */
export function getSessionMemberInfo(): {
  internalClientUuid: string | null
  userEmail: string | null
} {
  if (typeof window === 'undefined') {
    return { internalClientUuid: null, userEmail: null }
  }

  try {
    const decoded = getStytchJWT()
    return getSessionMemberInfoFromStytchPayload(decoded)
  } catch {
    return { internalClientUuid: null, userEmail: null }
  }
}
